import sreq from './_sreq';
import unitStatuses from './_unit_statuses';

const entries = [unitStatuses, sreq];

export const getAllowedSettingsEntries = () => entries.filter(({ permissionChecker }) => permissionChecker());

export const hasAnyCommunitySettingsAccess = () => getAllowedSettingsEntries().length > 0;
